// tempexp_18086-start
import { type PayloadAction, createAction, createReducer } from '@reduxjs/toolkit';

import type { ReferralProgramState } from './referralProgram.types';

const initialState: ReferralProgramState = {
    isLoading: false,
    isLoaded: false,
    hasError: false,
};
/** реферальная ссылка, которой мы можем делиться с другими */
const getReferralLinkRequest = createAction('referralProgram/getReferralLinkRequest');
const getReferralLinkSuccess = createAction<string>('referralProgram/getReferralLinkSuccess');
const getReferralLinkFailure = createAction('referralProgram/getReferralLinkFailure');
/** id реферальной ссылки, которой поделилилсь с нами */
const setRefId = createAction<string>('referralProgram/setRefId');
/** открытие реферальной ссылки на лендинге промоквоты */
const startPromoQuotaReferral = createAction('referralProgram/startPromoQuotaReferral');

export const referralProgramReducer = createReducer(initialState, {
    [getReferralLinkRequest.type]: (state) => {
        state.isLoading = true;
    },
    [getReferralLinkSuccess.type]: (state, { payload }: PayloadAction<string>) => {
        state.referralLink = payload;
        state.isLoading = false;
        state.isLoaded = true;
        state.hasError = false;
    },
    [getReferralLinkFailure.type]: (state) => {
        state.isLoaded = true;
        state.isLoading = false;
        state.hasError = true;
    },
    [setRefId.type]: (state, { payload }: PayloadAction<string>) => {
        state.ref_id = payload;
    },
});

export const ReferralProgramActions = {
    getReferralLinkRequest,
    getReferralLinkSuccess,
    getReferralLinkFailure,
    startPromoQuotaReferral,
    setRefId,
} as const;
// tempexp_18086-end
